import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SiteDeploymentNotReleasedErrorOptions = {
  deployment: ObjectId;
};

export class SiteDeploymentNotReleasedError extends FleekError<SiteDeploymentNotReleasedErrorOptions> {
  public name = 'SiteDeploymentNotReleasedError';

  toString = () => `Deployment not released.`;
}
